<template>
	<v-sheet elevation="0">
		<FunctionTitle title="" />
		<CommonFlame :title="'新規運送便見積依頼作成'">
			<!-- app-barに表示するボタン群 -->
			<template v-slot:app-bar-btn>
				<v-btn class="ma-1" color="primary" @click="$router.push({ name: 'logi_quotes' })">
					<v-icon class="mr-2">mdi-arrow-left</v-icon>
					戻る
				</v-btn>
			</template>
			<template>
				<v-form class="pa-2" ref="form" v-model="valid">
					<v-row no-gutters class="mx-1">
						<MatterSearch @setParentMatterId="setMatterId" @unsetParentMatterId="unsetMatterId" />
					</v-row>
					<h3 class="mx-1">納入先情報</h3>
					<v-row class="d-flex flex-wrap justify-center" no-gutters>
						<v-text-field
							v-model="logi_quote.prefecture"
							label="都道府県※必須"
							class="mt-2 mx-1"
							required
							outlined
							dense
							hide-details="auto"
						/>
						<v-text-field
							v-model="logi_quote.city"
							label="市郡町村※必須"
							class="mt-2 mx-1"
							required
							outlined
							dense
							hide-details="auto"
						/>
					</v-row>
					<v-row class="d-flex flex-wrap justify-center" no-gutters>
						<v-text-field
							v-model="logi_quote.address"
							label="住所 必須ではありません"
							class="mt-2 mx-1"
							outlined
							dense
							hide-details="auto"
						/>
					</v-row>
					<v-row class="d-flex flex-wrap justify-left" no-gutters>
						<div>
							<v-autocomplete
								v-model="logi_quote.car_model"
								class="mt-2 mx-1"
								label="車種※必須"
								:items="carModels"
								required
								outlined
								dense
								style="max-width: 250px"
								hide-details="auto"
							/>
							<p class="mt-1 mx-2 float-right caption hover-large" @click="openAddCarModel">
								<v-icon>mdi-plus</v-icon>車種追加
							</p>
						</div>
						<v-text-field
							type="number"
							v-model="logi_quote.number_of_cars"
							label="台数※必須"
							class="mt-2 mx-1"
							min="1"
							required
							outlined
							dense
							style="max-width: 80px"
							hide-details="auto"
						/>
						<v-select
							v-model="selectedSupplier"
							label="見積依頼先※必須"
							:items="suppliers"
							class="mt-2 mx-1"
							item-text="name"
							item-value="value"
							dense
							outlined
							return-object
							style="max-width: 200px"
							hide-details="auto"
							@change="setMailAddress"
						/>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12" sm="6">
							<v-combobox
								type="text"
								v-model="emails"
								label="TO"
								dense
								outlined
								hide-details="false"
								:class="{
									'mr-2': !$vuetify.breakpoint.xs,
								}"
								multiple
								small-chips
							/>
						</v-col>
						<v-col cols="12" sm="6">
							<v-combobox
								type="text"
								v-model="cc_emails"
								label="CC"
								:class="$vuetify.breakpoint.xs ? 'mt-4' : ''"
								dense
								outlined
								hide-details="false"
								multiple
								small-chips
							/>
						</v-col>
					</v-row>
					<v-text-field
						type="text"
						v-model="mail_info.title"
						label="メールタイトル※必須"
						class="mt-2 mx-1"
						required
						dense
						outlined
						hide-details="auto"
					/>
					<v-textarea
						v-model="mail_info.content"
						label="メール文章※必須"
						class="mt-2 mx-1"
						required
						outlined
						dense
						hide-details="auto"
					/>
				</v-form>
				<v-row no-gutters class="pb-2">
					<v-col cols="4"> </v-col>
					<v-col cols="4">
						<v-row no-gutters justify="center">
							<v-btn class="ma-1" color="secondary" @click="openConfirm" :disabled="disableBtn">
								<v-icon class="mr-2">mdi-checkbox-marked-outline</v-icon>
								作成する
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</template>
		</CommonFlame>
		<SimpleConfirm ref="confirm" @sendYes="createQuoteData()" />
		<AddCarModelDialog ref="addCar" @pushName="pushName" />
	</v-sheet>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import MatterSearch from "../shared/MatterSearch.vue"
import SimpleConfirm from "./components/SimpleConfirm.vue"
import AddCarModelDialog from "./components/AddCarModelDialog.vue"
export default {
	components: {
		FunctionTitle,
		CommonFlame,
		MatterSearch,
		SimpleConfirm,
		AddCarModelDialog,
	},
	data() {
		return {
			integerRules: [(v) => (v >= -99999 && v <= 99999) || "値の範囲は-99999〜99999です"],
			floatRules: [(v) => (v >= -999 && v <= 999) || "値の範囲は-999=〜999です"],
			rules: rules,
			valid: false,
			moment: moment,
			common: common,
			mainTitle: "運送費見積作成",
			emails: [],
			cc_emails: [],
			quote_request: {
				matter_id: "",
				supplier_id: "",
				status_type: "sent",
				quote_type: "transportation",
				title: "",
				remarks: "",
			},
			logi_quote: {
				prefecture: "",
				city: "",
				address: "",
				car_model: "",
				number_of_cars: "",
				price: "",
			},
			mail_info: {
				title: "お見積のお願い",
				content: "",
			},
			selectedMatter: null,
			carModels: [],
			suppliers: [],
			selectedSupplier: null,
			user: null,
		}
	},
	created() {
		this.fetchInfo()
		var date = new Date()
		var year = date.getFullYear()
		var month = date.getMonth() + 1
		var day = date.getDate()
		this.mail_info.title += " (" + year + "年" + month + "月" + day + "日" + ")"
	},
	methods: {
		necessaryCheck() {
			if (
				this.quote_request.matter_id == "" ||
				this.quote_request.supplier_id == "" ||
				this.mail_info.title == ""
			) {
				return true
			} else {
				return false
			}
		},
		setMailAddress() {
			this.emails = []
			this.emails.push(this.selectedSupplier.email)
		},
		openAddCarModel() {
			this.$refs.addCar.openDialog()
		},
		pushName(name) {
			console.log(name)
			this.carModels.push(name)
			this.logi_quote.car_model = name
		},
		setMatterId(matter) {
			this.quote_request.matter_id = matter.id
			this.selectedMatter = matter
			let addressInfo = this.common.yubinbango(matter.delivery_zipcode)
			if (addressInfo != null) {
				this.logi_quote.prefecture += addressInfo.prefecture
				this.logi_quote.city += addressInfo.city
				this.address = matter.delivery_address
			}
		},
		createQuoteData() {
			if (
				this.selectedSupplier != null &&
				this.logi_quote.car_model != "" &&
				this.logi_quote.number_of_cars != "" &&
				this.logi_quote.prefecture != "" &&
				this.logi_quote.city != ""
			) {
				const headers = authenticate.setHeader()
				headers["Content-type"] = "multipart/form-data"
				var formData = new FormData()
				formData.set("quote_request", JSON.stringify(this.quote_request))
				formData.set("logi_quote", JSON.stringify(this.logi_quote))
				formData.set("mail_info", JSON.stringify(this.mail_info))
				formData.set("emails", JSON.stringify(this.emails))
				formData.set("cc_emails", JSON.stringify(this.cc_emails))
				axios
					.post("/erp/v1/logi_quotes", formData, { headers })
					.then((res) => {
						this.$router.push({ name: "logi_quotes" })
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			}
		},
		openConfirm() {
			this.$refs.confirm.dialog = true
			this.$refs.confirm.title = "作成前確認"
			this.$refs.confirm.message =
				"メールはこのまま送信され、この内容で見積データを作成します。本当によろしいですか？"
		},
		unsetMatterId() {
			this.quote_request.matter_id = ""
			this.selectedMatter = {}
		},
		fetchInfo() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/logi_quotes/new.json", {
					headers,
				})
				.then((res) => {
					this.carModels = res.data.car_models
					this.suppliers = res.data.suppliers
					this.user = res.data.user
					this.cc_emails.push(this.user.email)
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		setMailTemplate() {
			if (
				this.selectedSupplier != null &&
				this.logi_quote.car_model != "" &&
				this.logi_quote.number_of_cars != "" &&
				this.logi_quote.prefecture != "" &&
				this.logi_quote.city != ""
			) {
				if (this.selectedSupplier.email) {
					let line_1 = this.selectedSupplier.name + "\n"
					let line_2 = this.selectedSupplier.pic_name + "様\n"
					let line_3 = "いつもお世話になっております。" + "\n"
					let line_4 = "極東ゴムの" + this.user.last_name + "です。" + "\n"
					let line_5 = "以下の条件にて、お見積りをお願い致します。" + "\n\n"
					let line_6 = "【お見積内容】" + "\n"
					let line_7 = "車種：" + this.logi_quote.car_model + "\n"
					let line_8 = "数量：" + this.logi_quote.number_of_cars + "台\n"
					let line_9 =
						"場所：" +
						this.logi_quote.prefecture +
						this.logi_quote.city +
						this.logi_quote.address +
						"\n\n"
					let line_10 = "以上、何卒よろしくお願いいたします。\n"
					let line_11 = "極東ゴム株式会社\n"
					let line_12 = this.user.last_name + " " + this.user.first_name
					let text =
						line_1 +
						line_2 +
						line_3 +
						line_4 +
						line_5 +
						line_6 +
						line_7 +
						line_8 +
						line_9 +
						line_10 +
						line_11 +
						line_12
					this.mail_info.content = text
				} else {
					text = "メールアドレスが登録されていません"
					this.mail_info.content = text
				}
			} else {
				this.mail_info.content = "必須項目を埋めてください"
			}
		},
	},
	watch: {
		selectedSupplier(newValue, oldValue) {
			this.quote_request.supplier_id = newValue.id
			this.setMailTemplate()
		},
		"logi_quote.car_model": function (val) {
			this.setMailTemplate()
		},
		"logi_quote.number_of_cars": function (val) {
			this.setMailTemplate()
		},
		"logi_quote.prefecture": function (val) {
			this.setMailTemplate()
		},
		"logi_quote.city": function (val) {
			this.setMailTemplate()
		},
	},
	computed: {
		disableBtn() {
			return !(
				this.quote_request.supplier_id &&
				this.mail_info.content &&
				this.mail_info.content != "必須項目を埋めてください" &&
				this.mail_info.content != "メールアドレスが登録されていません"
			)
		},
	},
}
</script>

<style scoped lang="scss">
.width50p {
	width: 45%;
}
@media (max-width: 600px) {
	.width50p {
		width: 100%;
	}
}
.hover-large {
	cursor: pointer;
	&:hover {
		font-size: 0.9rem !important;
	}
}
</style>
